<template>
    <div class="right-inner__header position-relative">
        <h1 class="service-detail__title notranslate" :title="productData.name">
            <span v-html="formatTitle(productData.name)"></span>
        </h1>

        <ProductFavoriteButton v-show="authUser" :product="productData" class="detailFavorite" />

        <GiftEvents
            v-if="productData.giftActions?.length"
            :gift-actions="productData.giftActions.slice(0, 1)"
            :product="productData"
            refresh-discount-price
            orange-background
            class="mt-2 mb-3 d-none d-md-block"
        />

        <div v-if="productData.productRating && productData.productRating.averageRating > 3" class="block-links" data-cy="rating">
            <ObjectsRating :rating="productData.productRating.averageRating" :total="productData.productRating.totalReviews" :box="true" />
            <a
                v-if="productData.comments.total > 0"
                class="px-3 block-links-link"
                href="#tab-reviews"
                @click="sendActiveTab('tab-reviews')"
                v-html="$t('serviceDetail.commentsRead', productData.productRating.totalReviews)"
            />

            <!--            <a v-if="productData.discussion" href="#tab-discussion" @click="sendActiveTab('tab-discussion')">-->
            <!--                {{ $t('serviceDetail.questionRead', productData.questionRead) }}-->
            <!--            </a>-->
        </div>
    </div>
</template>
<script lang="ts">
import { PropType } from 'vue'
import ProductFavoriteButton from '~/components/objects/ProductFavoriteButton.vue'
import { useBasketStore } from '~/stores/basket'
import FullProduct from '~/models/Product/FullProduct'
import GiftEvents from '~/components/layout/productDetail/GiftEvents.vue'

export default {
    components: {
        GiftEvents,
        ProductFavoriteButton,
    },
    props: {
        isSmall: {
            type: Boolean,
            default: false,
        },
        productData: {
            type: Object as PropType<FullProduct>,
            default: null,
        },
        productTitleSuffix: {
            type: String,
            default: '',
        },
    },
    computed: {
        authUser(): object | null {
            const basketStore = useBasketStore()

            return basketStore.authUser
        },
    },
    methods: {
        formatTitle(title: string): string {
            const stripSpaceSymbol = this.$t('stripSpaceSymbol')
            const spaceRegex = new RegExp(` (?=${stripSpaceSymbol})`, 'g')
            const suffix = this.productTitleSuffix !== '' ? this.$t(this.productTitleSuffix) : ''
            return title.replace(spaceRegex, '&nbsp;') + suffix
        },

        sendActiveTab(tabId: string): void {
            useNuxtApp().$bus.$emit('setActiveTab', tabId)
        },
    },
}
</script>
<style lang="scss" scoped>
.block-links {
    font-size: 13px;
    white-space: nowrap;
    padding: 10px 0 4px;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    cursor: pointer;
}

.block-links-link {
    color: $color-dark;
    text-decoration: none;

    &:hover {
        text-decoration: underline;
    }
}

.service-detail__title {
    font-size: 1.5em;
    width: calc(100% - 40px);
    line-height: 1.2;
    font-weight: 500;
    margin-top: -8px;
    font-family: 'scale-variable', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans',
        'Droid Sans', 'Helvetica Neue', sans-serif;
    font-variation-settings: 'wght' 700, 'wdth' 100;
}
</style>
